import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom"
import Api from '../servicios/api';
import {Header, Titulo, ContenedorHeader, ContenedorBotones} from '../elementos/Header'
import {ContenedorBotonesLista, BotonEditar, BotonEliminar, Buscador, ContenedorBuscador, InputBuscador} from '../elementos/ElementosDeLista'
import {ReactComponent as IconoEditar} from '../imagenes/editar.svg'
import {ReactComponent as IconoBorrar} from '../imagenes/borrar.svg'
import { FaSearch } from "react-icons/fa";
import Boton from '../elementos/Boton'
import Alerta from '../elementos/Alerta'
import Cargando from '../elementos/Cargando'
import VentanaModal from '../elementos/VentanaModal'


const ListarPublicaciones = () => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [publicaciones, setPublicacion] = useState([]);
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [modal, setModal] = useState({});
    const [estadoModal, setEstadoModal] = useState(false);
    const [idEliminar, setidEliminar] = useState();
    const [buscador, setBuscador] = useState();

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        cargarDatos();
    }, [buscador]);

    const cargarDatos = () => {
        var datosEnviar;

        if(buscador){
            datosEnviar = {busqueda: buscador}
        }

        fetch(Api+"?consultarPublicaciones",{
            method:"POST",
            body:JSON.stringify(datosEnviar)
        })
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setPublicacion(datosRespuesta);
        })
        .catch(console.log)
        
    }

    const handleChange = (e) => {
        switch(e.target.name){
            case 'buscador':
                setBuscador(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleModal = (id) => {
        setidEliminar(id);
        setEstadoModal(true);
        setModal({
            header: 'Eliminar Publicación',
            body: '¿Está seguro de eliminar la publicación?'
        });
    }

    const borrarRegistro = ()=> {
        setEstadoModal(false);
        setEstadoAlerta(false);
        setAlerta({});
        
        fetch(Api+"?borrarPublicacion="+idEliminar)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setEstadoAlerta(true);
            setAlerta({
                tipo: 'exito',
                mensaje: 'Publicación eliminada correctamente.'
            });
            cargarDatos();
        })
        .catch(console.log)
    }

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <Header>
                    <ContenedorHeader>
                        <Titulo>Lista de Publicaciones</Titulo>
                        <ContenedorBotones>
                            <Boton to="/crear-publicacion" primario="true">Agregar Publicación</Boton>
                        </ContenedorBotones>
                    </ContenedorHeader>
                </Header>

                <Buscador>
                    <ContenedorBuscador>
                        <InputBuscador
                            type="text"
                            name="buscador"
                            placeholder="Ingrese título, autor, tipo o año de publicación"
                            value={buscador}
                            onChange={handleChange}
                        />
                        <i className='icono-buscador'><FaSearch /></i> 
                    </ContenedorBuscador>
                </Buscador>

                <div className="contenedor-tabla">
                    <div className="card card-tamano card-tamano-busqueda">
                        <div className="card-body card-body-tamano">
                            <table className="table table-striped justificar-fila" id="example">
                                <thead>
                                    <tr>
                                        <th>Título</th>
                                        <th>Año</th>
                                        <th>Autor</th>
                                        <th>Tipo</th>
                                        <th>Ruta</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        publicaciones.success !== 0 &&
                                            publicaciones.map(
                                                (publicacion)=>(
                                                    <tr key={publicacion.Pub_ID}>
                                                        <td>{publicacion.Pub_Titulo}</td>
                                                        <td>{publicacion.Pub_Anio}</td>
                                                        <td>{publicacion.Aut_Nombre}</td>
                                                        <td>{publicacion.TPub_Nombre}</td>
                                                        <td>{publicacion.Pub_RutaArchivo}</td>
                                                        <td>
                                                            <ContenedorBotonesLista>
                                                                <BotonEditar title="Actualizar Publicación" as={Link} to={"/editar-publicacion/"+publicacion.Pub_ID}>
                                                                    <IconoEditar />
                                                                </BotonEditar>
                                                                
                                                                <BotonEliminar title="Eliminar Publicación" onClick={() => handleModal(publicacion.Pub_ID)}>
                                                                    <IconoBorrar />
                                                                </BotonEliminar>
                                                            </ContenedorBotonesLista>
                                                        </td>
                                                    </tr>
                                                )
                                            )
                                    }              
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                
                
                <Alerta 
                        tipo={alerta.tipo}
                        mensaje={alerta.mensaje}
                        estadoAlerta={estadoAlerta}
                        setEstadoAlerta={setEstadoAlerta}
                />

                <VentanaModal
                        mensajeHeader={modal.header}
                        mensajeBody={modal.body}
                        estadoModal={estadoModal}
                        setEstadoModal={setEstadoModal}
                        handleConfirm={borrarRegistro}
                />
            </>
        );
    }
}

export default ListarPublicaciones;